import { Component, ViewChild, ElementRef, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from './popup-component';

@Component({
  selector: 'app-camera-view',
  templateUrl: './camera-view.component.html',
  styleUrls: ['./camera-view.component.css']
,
  standalone: false
})
export class CameraViewComponent {
  filterOptions = ['15m', '1h', '4h', '1D', '1W', '1M', '2M'];
  isThumbnailsVisible = true;
  cameras = [
    { id: 'cam01', name: 'F3292 Cam 06' },
    { id: 'cam02', name: 'F3292 Cam 07' }
  ];
  selectedCamera = 'cam01';

//   timeRanges = ['15m', '1h', '4h', '1D', '1W', '1M'];
  timeRanges = ['15m', '1h', '4h', '1D'];
  moreTimeRanges = ['2h', '8h', '12h', '2D', '2W', '2M'];
  selectedDateRange: Date | null = null;
  thumbnails:any = [
    {
      imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
      time: '14-10-2024 3:00pm',
      details: 'Motion detected near the entrance at 3:00pm.',
      isSelected: false
    },
    {
      imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM85289&withmd=true&station=recordingStation11&farm=8442',
      time: '14-10-2024 3:15pm',
      details: 'Motion detected near the parking area at 3:15pm.',
      isSelected: false
    },
    {
      imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
      time: '14-10-2024 3:30pm',
      details: 'Suspicious activity detected near the side entrance at 3:30pm.',
      isSelected: false
    },
    {
      imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
      time: '14-10-2024 3:45pm',
      details: 'Motion detected in the back alley at 3:45pm.',
      isSelected: false
    },
    {
      imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
      time: '14-10-2024 4:00pm',
      details: 'Person detected near the front gate at 4:00pm.',
      isSelected: false
    },
    {
      imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
      time: '14-10-2024 4:15pm',
      details: 'Vehicle detected at the main entrance at 4:15pm.',
      isSelected: false
    },
    {
      imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
      time: '14-10-2024 4:30pm',
      details: 'Suspicious activity near the loading dock at 4:30pm.',
      isSelected: false
    },
    {
        imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
        time: '14-10-2024 3:00pm',
        details: 'Motion detected near the entrance at 3:00pm.',
        isSelected: false
      },
      {
        imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM85289&withmd=true&station=recordingStation11&farm=8442',
        time: '14-10-2024 3:15pm',
        details: 'Motion detected near the parking area at 3:15pm.',
        isSelected: false
      },
      {
        imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
        time: '14-10-2024 3:30pm',
        details: 'Suspicious activity detected near the side entrance at 3:30pm.',
        isSelected: false
      },
      {
        imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
        time: '14-10-2024 3:45pm',
        details: 'Motion detected in the back alley at 3:45pm.',
        isSelected: false
      },
      {
        imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
        time: '14-10-2024 4:00pm',
        details: 'Person detected near the front gate at 4:00pm.',
        isSelected: false
      },
      {
        imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
        time: '14-10-2024 4:15pm',
        details: 'Vehicle detected at the main entrance at 4:15pm.',
        isSelected: false
      },
      {
        imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
        time: '14-10-2024 4:30pm',
        details: 'Suspicious activity near the loading dock at 4:30pm.',
        isSelected: false
      },
      {
        imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
        time: '14-10-2024 3:00pm',
        details: 'Motion detected near the entrance at 3:00pm.',
        isSelected: false
      },
      {
        imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM85289&withmd=true&station=recordingStation11&farm=8442',
        time: '14-10-2024 3:15pm',
        details: 'Motion detected near the parking area at 3:15pm.',
        isSelected: false
      },
      {
        imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
        time: '14-10-2024 3:30pm',
        details: 'Suspicious activity detected near the side entrance at 3:30pm.',
        isSelected: false
      },
      {
        imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
        time: '14-10-2024 3:45pm',
        details: 'Motion detected in the back alley at 3:45pm.',
        isSelected: false
      },
      {
        imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
        time: '14-10-2024 4:00pm',
        details: 'Person detected near the front gate at 4:00pm.',
        isSelected: false
      },
      {
        imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
        time: '14-10-2024 4:15pm',
        details: 'Vehicle detected at the main entrance at 4:15pm.',
        isSelected: false
      },
      {
        imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
        time: '14-10-2024 4:30pm',
        details: 'Suspicious activity near the loading dock at 4:30pm.',
        isSelected: false
      }
  ];
  selectedThumbnail: any;

  @ViewChild('scrollContainer') thumbnailContainer: ElementRef;
  showLeftNav = false;
  showRightNav = false;
  observer: IntersectionObserver;

  @ViewChild('loadMoreObserver', { static: false }) loadMoreObserver: ElementRef;

  constructor(public dialog: MatDialog) {

    this.loadInitialThumbnails();

    // for (let i = 1; i < 10000; i++) {
    //     this.thumbnails.push(
    //         {
    //             imageUrl: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442',
    //             time: '14-10-2024 4:30pm',
    //             details: 'Suspicious activity near the loading dock at 4:30pm.',
    //             isSelected: false
    //           }
    //     );
    //     console.log("Happy Birthday");
    // }
  }

  ngAfterViewInit() {
    // Restore the saved scroll position on view initialization
    if (this.isThumbnailsVisible) {
        this.updateNavigationButtons();
        this.setupObserver();
    }
  }

  applyFilter(option: string) {
    // Filter thumbnails based on selected filter option
  }

  onScroll(event: Event) {
    // Save the current scroll position
    //this.savedScrollPosition = (event.target as HTMLElement).scrollLeft;
    this.updateNavigationButtons();
  }

  @HostListener('window:resize')
  onResize() {
    this.updateNavigationButtons();
    console.log('on resize');
  }

  private updateNavigationButtons() {
    if (this.isThumbnailsVisible) {
        const container = this.thumbnailContainer.nativeElement;
        this.showLeftNav = container.scrollLeft > 0;
        this.showRightNav = container.scrollLeft < container.scrollWidth - container.clientWidth;    
    }
  }

  scrollLeft() {
    this.thumbnailContainer.nativeElement.scrollBy({ left: -150, behavior: 'smooth' });
  }

  scrollRight() {
    this.thumbnailContainer.nativeElement.scrollBy({ left: 150, behavior: 'smooth' });
  }

  selectTimeRange(range: string) {
    console.log(`Selected time range: ${range}`);
  }

  openPopup(thumbnail) {
    this.thumbnails.forEach(t => t.isSelected = false);
    thumbnail.isSelected = true;

    this.selectedThumbnail = thumbnail;
    this.dialog.open(PopupComponent, {
      data: thumbnail
    });
  }
  onDateRangeChange() {
    console.log(`Selected date range: ${this.selectedDateRange}`);
  }

  loadInitialThumbnails() {
    // Load the initial batch of thumbnails (e.g., first 20)
    this.thumbnails = this.fetchThumbnails(0, 20);
  }

  ngOnDestroy() {

    this.observer.disconnect();
  }

  setupObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadMoreThumbnails();
        }
      });
    });

    if (this.loadMoreObserver) {
      this.observer.observe(this.loadMoreObserver.nativeElement);
    }
  }

  loadMoreThumbnails() {
    const currentLength = this.thumbnails.length;
    const moreThumbnails = this.fetchThumbnails(currentLength, currentLength + 20);
    this.thumbnails = [...this.thumbnails, ...moreThumbnails];
  }

  fetchThumbnails(start: number, end: number) {
    // Replace this with an actual API call or data fetch logic
    const thumbnails = [];
    for (let i = start; i < end; i++) {
      thumbnails.push({
        imageUrl: `https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=753708F3605CAM34868&withmd=true&station=recordingStation&farm=8442`,
        cameraName: `F3412 Cam 01`,
        time: `14-10-2024 11:${45 + i % 60}pm`,
        isSelected: false,
        details: `Motion detected near the parking area at 11:${45 + i % 60}pm.`,

      });
    }
    return thumbnails;
  }

  toggleThumbnails() {
    if(document.getElementById('isThumbnailsVisible').style.display == 'block') {
        document.getElementById('isThumbnailsVisible').style.display = 'none';
    } else  {
        document.getElementById('isThumbnailsVisible').style.display = 'block'
    }
    document.getElementById('isThumbnailsVisible').style.visibility = 'unset';

    this.isThumbnailsVisible = !this.isThumbnailsVisible;
  }

}
